'use client';

import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { useContext } from 'react';
import { FormContext } from '../index.js';
import TextEditor from '../../TextEditor/index.js';
import s from './TextEditor.module.scss.js';

var FMTextEditor = function (_a) {
    var name = _a.name, label = _a.label, isRequired = _a.isRequired, onError = _a.onError, textEditorRef = _a.textEditorRef, rest = __rest(_a, ["name", "label", "isRequired", "onError", "textEditorRef"]);
    var _b = useContext(FormContext), values = _b.values, setValues = _b.setValues, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError, errors = _b.errors;
    var content = values[name] || '';
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    var onChange = function (content) {
        var _a;
        setValues(__assign(__assign({}, values), (_a = {}, _a[name] = content, _a)));
        onAnyChange(content, name);
        if (onError) {
            onError(showError);
        }
    };
    /* Render */
    return (React__default.createElement("div", null,
        label ? (React__default.createElement("div", { className: s.labelWrapper },
            isRequired ? React__default.createElement("span", { className: 'text-danger' }, "*") : null,
            " ",
            React__default.createElement("label", null, label))) : null,
        React__default.createElement(TextEditor, __assign({}, rest, { ref: textEditorRef, content: content, onChange: onChange, onFocus: function (event) {
                var _a;
                event.preventDefault();
                setTouched(__assign(__assign({}, touched), (_a = {}, _a[name] = true, _a)));
            }, isError: showError })),
        showError && React__default.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
};

export { FMTextEditor as default };
//# sourceMappingURL=index.js.map
